export const FONT_FAMILY = 'Plus Jakarta Sans'
